import Guid from '@/app/utils/guid'
import Entity from '@/common/models/entity'

export default class EvaluationBasicDto extends Entity {
  public title = ''
  public description = ''
  public companyName = ''
  public remarks = ''
  public applicationsCount = 0
  public dbApplicationsCount = 0
  public interviewsCount = 0
  public moderatorId = Guid.empty()
  public referenceNumber = ''
}
